import React, { useMemo } from "react";
import RffFormChanges from "../components/finalForm/RffFormChanges";

import { Field, useForm, useFormState } from "react-final-form";
import { useDispatch } from "react-redux";
import RffInputWrapper from "../components/finalForm/shared/RffInputWrapper";
import SelectFileAssignmentInput from "../components/inputs/SelectFileAssignmentInput";
import TextInput from "../components/inputs/TextInput";
import InputWrapper from "../components/inputs/shared/InputWrapper";
import Flx from "../components/layout/Flx";
import { useBorrowerPortalHook } from "../hooks/useBorrowerPortalHook";
import { VALIDATOR_REQUIRE } from "../utils/finalForm/validators/VALIDATOR_REQUIRE";

const EditBorrowerDocumentMetadataForm = ({
  file,
  borrowerId,
  onSuccessFn,
}) => {
  const { loading, updateBorrowerDocMetadata } = useBorrowerPortalHook();
  const dispatch = useDispatch();
  const onSubmit = (changedValues, { form, values, changes }) => {
    const payload = [{ _id: file._id || file?.oid, ...changedValues }];
    // console.log("payload", payload);

    updateBorrowerDocMetadata({
      borrowerId: borrowerId,
      files: payload,
      onSuccessFn,
    });
  };

  const initialValues = useMemo(() => {
    return {
      file_display_name: file?.file_display_name,
      docGroup: file?.docGroup,
      docType: file?.docType,
    };
  }, [file]);

  return (
    <RffFormChanges
      loading={loading}
      initialValues={initialValues}
      onSubmit={onSubmit}
    >
      <RffDocumentMetaData fileNameAsLoaded={file?.file_name_as_loaded} />
    </RffFormChanges>
  );
};

const RffDocumentMetaData = ({ sx, fileNameAsLoaded }) => {
  const {
    values: { docGroup, docType },
  } = useFormState();
  const { change } = useForm();

  const onDocGroupChange = (dg, dt) => {
    change("docGroup", dg);
    change("docType", dt); // Reset docType when docGroup changes
  };

  return (
    <Flx column fw gap={4} sx={sx}>
      <RffFileDisplayName
        name="file_display_name"
        suppressGrid
        label="File Display Name"
        fileNameAsLoaded={fileNameAsLoaded}
      />
      <InputWrapper fullWidth label={`Document Type`}>
        <SelectFileAssignmentInput
          placeholder="Search document categories and types..."
          onChange={(params) => {
            onDocGroupChange(params?.docGroup, params?.docType);
          }}
          onlyDisplayDocType
          docGroup={docGroup}
          docType={docType}
          sx={{ mb: 3 }}
        />
      </InputWrapper>
    </Flx>
  );
};

const RffFileDisplayName = React.memo(function RffFileDisplayName({
  name,
  label,
  required,
  placeholder = "",
  suppressGrid = false,
  size,
  helperText,
  disabled,
  fileNameAsLoaded,
  testing,
  sx,
}) {
  // Only recreate validator when "required" changes
  const validate = useMemo(
    () => (required ? VALIDATOR_REQUIRE : undefined),
    [required],
  );

  return (
    <RffInputWrapper
      label={label}
      suppressGrid={suppressGrid}
      size={size}
      required={required}
      testing={testing}
    >
      <Field
        name={name}
        validate={validate}
        // Subscribe to meta.initial for original value
        subscription={{
          value: true,
          touched: true,
          error: true,
          initial: true,
        }}
        render={({ input, meta }) => {
          const handleBlur = (event) => {
            // First update form state
            input.onBlur(event);

            // Determine original extension from initial value
            // console.log("meta", meta.data);
            const originalName = fileNameAsLoaded || "";
            const originalExtension = originalName
              .split(".")
              .pop()
              .toLowerCase();

            // Strip any extension from current input
            const currentValue = input.value || "";
            const baseName = currentValue.replace(/\.[^/.]+$/, "");

            // Reapply original extension
            const updatedName = `${baseName}.${originalExtension}`;
            if (updatedName !== currentValue) {
              input.onChange(updatedName);
            }
          };

          return (
            <TextInput
              {...input}
              sx={sx}
              onBlur={handleBlur}
              disabled={disabled}
              placeholder={placeholder}
              error={meta.touched && !!meta.error}
              helperText={(meta.touched && meta.error) || helperText}
            />
          );
        }}
      />
    </RffInputWrapper>
  );
});
export default EditBorrowerDocumentMetadataForm;
